__turbopack_context__.v({
  "spin": "styles-module-scss-module__jd8z-a__spin",
  "spinner": "styles-module-scss-module__jd8z-a__spinner",
});
